import Dialog from './dialog/Dialog';
import QuickQs from './quick-qs/QuickQs';
import InputArea from './input-area/InputArea';
import Tool from './tool/Tool';
import Evaluate from './evaluate/Evaluate';
import { Toast, Indicator } from 'mint-ui';
import { dataHandle } from '../../services/data-handle.js'
import { CHAT } from '../../services/socket.js';
import {v4} from 'uuid';
export default {
    components: {
        'conversation': Dialog,
        'quick-li': QuickQs,
        'input-area': InputArea,
        'tool': Tool,
        'evaluate': Evaluate
    },
    data() {
        return {
            accessKey: '',
            socketConnected: false,
            firstConnected: true,
            clientId: '',
            businessId: '',
            businessName: '',
            businessType: sessionStorage.getItem('businessType') || 1, //1-普通问答机器人，2-文档问答机器人
            businessTypeList: [],
            conversationH: 0,
            historyList: [],
            smartList: [],
            maskShow: false,
            historyFinished: false,
            historyRequested: false,  // 当前历史记录是否请求完
            chatList: [],
            welcomeText: '',
            quickQsList: [],
            cid: '', // conversationId 会话id
            firstGetHistory: true,
            toolShow: false,
            artificialLink: '',
            evaluateShow: false,
            customerType: 0, //0-普通用户，1-VIP用户
            clientType: '1', //1-H5,2-微信，3-企业微信
            queue: 0, //人工客服排队，0-不排队，1-排队中
            queuing: 0, //是否再队列中，0-否，1-队列中
            sessionKey: '',
            firstMsgId: '',
            isReconnect: false,
            phone:'',
            errorText:'',
            showModal:false,
            hasMobeil:false
        }
    },
    mounted() {
        Indicator.open('聊天连接中...');
        this.businessId = sessionStorage.getItem('business');
        this.businessName = sessionStorage.getItem('businessName');
        this.accessKey = sessionStorage.getItem('accessKey');
        this.clientId = localStorage.getItem('bot-clientId');
        if (!this.clientId || this.clientId == 'undefined') {
            this.clientId = v4();
        }
        if (sessionStorage.getItem('skillGroups')) {
            this.businessTypeList = JSON.parse(sessionStorage.getItem('skillGroups'));
        }
        localStorage.setItem('bot-clientId', this.clientId);
        if(!this.businessId) {
            let instance = Toast('请先选择您要咨询的产品');
            setTimeout(() => {
                this.$router.replace({
                    name: 'business',
                    query: {
                        accessKey: this.accessKey
                    }
                });
                Indicator.close();
                instance.close();
            }, 1000);
            return;
        }
        this.init();
        window.onresize = () => {
            this.getConversationH();
        }
        setTimeout(() => {
            // 聊天内容，向上滚动加载更多
            this.$refs['conversation'].addEventListener('scroll',()=>{
                this.$refs.comConversation.closeContextmenu();
                this.firstMsgId = this.chatList[0].msgId || '';
                if(this.$refs['conversation'] && this.$refs['conversation'].scrollTop <= 10 && !this.historyFinished && this.historyRequested){
                    let times = dataHandle.getDateTimes(this.chatList[0].date);
                    this.getChatHistory(times);
                }
            });
        }, 500)
        this.hasMobeil = !dataHandle.getCookie('X-User-Mobile')
    },
    methods: {
        async init(){
            if (!this.socketConnected) {
                await CHAT.init('');
                await this.onConnect();
            }
            this.getChatHistory();
            this.getHotQs();
            this.getSmartList();
        },
        /**
         * 获取渠道类型
         * 1：H5
         * 2：微信
         * 3：企业微信
         * */
        getClientType(){
            this.clientType = 1;
            var ua = navigator.userAgent.toLowerCase();
            if(ua.match(/MicroMessenger/i)=="micromessenger") {
                if (ua.match(/wxwork/i) == 'wxwork') {
                    this.clientType = 3;
                }else{
                    this.clientType = 2;
                }
            }
        },
        /**
         * 计算对话内容高度
         */
        getConversationH() {
            let pageH = document.body.clientHeight;
            let businessH = this.$refs['business'].clientHeight;
            let bottomH = this.$refs['bottom'].clientHeight;
            let height = pageH-businessH-bottomH-4;
            if(sessionStorage.getItem('showPageHeader')&&sessionStorage.getItem('showPageHeader') != "undefined") {
                height = height - 44;
                let statusBarHeight = sessionStorage.getItem('statusBarHeight') || 20;
                height = height - statusBarHeight;
            }
            this.conversationH = height;
            this.maskShow = true;
        },
        /**
         * 获取历史记录
         * @param { Number } times => 时间
         */
        async getChatHistory(times) {
            if(this.historyFinished) return;
            this.loadHistory(times, false);
        },
        /**
         * 重新加载会话记录
         * */
        reloadChatHistory(){
            this.historyList = [];
            this.loadHistory(Date.now(), true);
        },
        /**
         * 添加会话记录到聊天框
         * */
        async loadHistory(times, reload){
            this.historyRequested = false;
            let res = await this.$http.get('/history', {
                date: times,
                accessKey: this.accessKey,
                clientId: this.clientId
            });
            return new Promise((resolve, reject) => {
                if(!res || !res.data) {
                    resolve('finished');
                }
                if (res.data.length < 10) {
                    this.historyFinished = true;
                    resolve('finished');
                }
                if (res.data && res.data.length) {
                    resolve('loaded');
                };
                let starInfo;
                for (let item of res.data) {
                    // 不展示人脸识别结果、身份认证结果
                    if (item.type === 'event' && ['facedetection', 'verify'].includes(item.eventKey)) {
                        continue;
                    }
                    if (item.type == 'event' && item.eventKey == 'satisfaction') {
                        starInfo = this.getStarInfo(item.manual);
                        item.manual.starInfo = starInfo;
                        if (!item.manual.labels) {
                            item.manual.labels = [];
                            item.manual.content = '';
                            item.manual.disabled = false;
                        }
                    }
                    this.historyList.unshift(item);
                }
                this.chatList = this.historyList;
                if (reload) {
                    // 滚动加载
                    this.scrollBottom();
                    this.historyRequested = true;
                }else{
                    // 首次加载
                    if(this.firstGetHistory) {
                        this.getNotice();
                        this.scrollBottom();
                    }else{
                        this.$nextTick(()=>{
                            if (this.firstMsgId != '' && this.$children[0].$refs['dialog_'+this.firstMsgId]) {
                                this.$children[0].$refs['dialog_'+this.firstMsgId][0].scrollIntoView();
                            }
                        });
                    }
                    this.historyRequested = true;
                    this.firstGetHistory = false;
                }
            })
        },
        /**
         * 获取满意度列表
         * */
        getStarInfo(item){
            let obj = {};
            if (item.level) {
                obj.defaultStar = item.level;
            }else{
                obj.defaultStar = item.satisfaction.defaultStar;
            }
            obj.maxLabelCount = item.satisfaction.maxLabelCount || 0;
            obj.showLabel = item.satisfaction.showLabel || false;
            obj.showTextView = item.satisfaction.showTextView || false;
            obj.textViewText = item.satisfaction.textViewText || '';
            let list = [];
            if (item.satisfaction.config) {
                for (var i = 1; i <= 5; i++) {
                    if (i == 1) {
                        list.push({
                            key: i,
                            labels: item.satisfaction.config['one'].labels,
                            remark: item.satisfaction.config['one'].remark
                        })
                    }else if (i == 2) {
                        list.push({
                            key: i,
                            labels: item.satisfaction.config['two'].labels,
                            remark: item.satisfaction.config['two'].remark
                        })
                    }else if (i == 3) {
                        list.push({
                            key: i,
                            labels: item.satisfaction.config['three'].labels,
                            remark: item.satisfaction.config['three'].remark
                        })
                    }else if (i == 4) {
                        list.push({
                            key: i,
                            labels: item.satisfaction.config['four'].labels,
                            remark: item.satisfaction.config['four'].remark
                        })
                    }else if (i == 5) {
                        list.push({
                            key: i,
                            labels: item.satisfaction.config['five'].labels,
                            remark: item.satisfaction.config['five'].remark
                        });
                    }
                }
            }
            obj.list = list;
            return obj;
        },
        /**
         * 获取通知
         * @returns
         */
        async getNotice() {
            let res = await this.$http.get('/notice',{
              accessKey: this.accessKey,
              skillGroupId: this.businessId
            });
            if(res.data && res.data.enable) {
                this.chatList.push({
                    type: 'notice',
                    content: res.data.content,
                    status: 'success',
                    date: Date.now()
                });
                this.scrollBottom();
            }
        },
        /**
         * 获取智能提示列表
         * @returns
         */
        async getSmartList() {
            let res = await this.$http.get(`/qa?accessKey=${this.accessKey}&skillGroupId=${sessionStorage.getItem('business')}`);
            if(!res || !res.data.length) return;
            this.smartList = [];
            for (let item of res.data) {
              if (item.question) this.smartList.push(item.question);
              if (item.qa_similars.length) {
                for (let list of item.qa_similars) {
                  if (list.question) this.smartList.push(list.question);
                }
              }
            }
        },
        /**
         * 获取热门问题
         */
        async getHotQs() {
            let res = await this.$http.get('/hot',{
                skillGroupId: this.businessId
            });
            if(res && res.data.length) {
                this.quickQsList = [];
                for (let item of res.data) {
                    this.quickQsList.push({
                        head_content: item.category,
                        list: []
                    });
                    for(let list of item.qas) {
                        this.quickQsList[this.quickQsList.length-1].list.push({
                            content: list
                        })
                    }
                }
            }
            this.$nextTick(()=> { // 得到热门问题后才可以加载聊天内容高度，否则不准
                this.getConversationH();
            });
        },
        /**
         * 聊天内容添加一条list
         *
         * @param { Object } list  ==> 需要添加的list
         */
        pushList(list) {
            this.chatList.push(list);
        },
        /**
         * 消息发送后的回调，用来修改消息发送状态
         * */
        sendMsgCallback2Status(res){
            let index = -1
            for (var i = this.chatList.length - 1; i >= 0; i--) {
                if (this.chatList[i].msgId == res.msgId) {
                    index = i;
                    break;
                }
            }
            if(res.ret == -1){
              this.$set(this.chatList[index], 'status', 'fail');
              Toast(res.msg);
            }else{
              this.$set(this.chatList[index], 'status', 'success');
            }
        },
        /**
         * 消息发送超时
         * @msgId：消息ID
         * @second: 延迟时间，单位秒
         * */
        sendMsgTimeout(msgId, second){
            const ms = (second || 2) * 1000;
            setTimeout(()=>{
                for (var i = this.chatList.length - 1; i >= 0; i--) {
                    if (this.chatList[i].msgId == msgId && this.chatList[i].status == 'loading') {
                        this.$set(this.chatList[i], 'status', 'fail');
                        break;
                    }
                }
                if (this.businessType == 2) {
                    // 解锁输入框（文档问答发送消息后已对输入框上锁）
                    this.$refs.inputArea.unlock();
                }
            }, ms);
        },
        /**
         * 连接Socket
         *
         */
        onConnect() {
            CHAT.socket.on('connect', () => {
                this.connented();
                this.onDisconnect();
            });

            // 监听消息
            CHAT.socket.on('message', (msg) => {
                // console.log('resolve0000', JSON.stringify(msg));
                this.wsOnmessage(msg);
            });
    
            CHAT.socket.on('event', (res) => {
                // console.log('----'+JSON.stringify(res));
                // 判断消息是否接收成功
                if (res.type === 'msgState') {
                    let index = -1;
                    for (let i in this.chatList) {
                        if (this.chatList[i].msgId == res.msgId) {
                            index = i;
                        }
                    }
                    if (res.result.code == 0) {
                        this.chatList[index].status = 'success';
                    } else {
                        this.chatList[index].status = 'fail';
                    }
                }else if (res.type == 'queue:notify') {
                    for (var i = this.chatList.length - 1; i >= 0; i--) {
                        if(this.chatList[i].type == 'queue:notify'){
                           this.chatList.splice(i, 1);
                           break; 
                        }
                    }
                    this.queue = 1;
                    // 排队等待-更新显示
                    this.chatList.push({
                        type: 'queue:notify',
                        date: Date.now(),
                        content: res.content,
                        manual: res.manual
                    });
                    this.scrollBottom();
                }else if (res.type == 'queue:done') {
                    for (var i = this.chatList.length - 1; i >= 0; i--) {
                        if(this.chatList[i].type == 'queue:notify'){
                           this.chatList.splice(i, 1);
                           break; 
                        }
                    }
                    this.queuing = 1;
                    this.queue = 0;
                    // 需重新计算高度
                    this.$nextTick(()=>{
                        this.getConversationH();
                    });
                }else if (res.type  == 'session:begin') {
                    // 开始会话

                }else if (res.type  == 'session:end') {
                    // 会话结束
                    this.queuing = 0;
                    this.queue = 0;
                    // 需重新计算高度
                    this.$nextTick(()=>{
                        this.getConversationH();
                    });
                }else if(res.type == 'recall'){
                    for (var i = 0; i < this.chatList.length; i++) {
                        if (this.chatList[i].msgId === res.msgId) {
                            this.chatList.splice(i, 1);
                            break;
                        }
                    }
                }
            });
        
            CHAT.socket.io.on('reconnect', () => {
                this.isReconnect = true;
                Indicator.close();
            });
        },
        /**
         * 断开链接
         *
         * @param { Object } data ==> 
         */
        onDisconnect(data) {
            CHAT.socket.on('disconnect', () => {
                this.socketConnected = false;
                Indicator.open('聊天断开，重连中...');
                if (!data) return;
            });
        },
        /**
         * socket 已连接
         */
        connented() {
            this.socketConnected = true;
            Indicator.close();
            if (!this.clientId || this.clientId == "undefined") {
                this.clientId = v4(); //生成uuId
                localStorage.setItem('bot-clientId', this.clientId);
            }
            let account = '';
            if(dataHandle.getCookie('X-User-Mobile')&&dataHandle.getCookie('X-User-Mobile') != "undefined") {
                account = dataHandle.getCookie('X-User-Mobile');
            }
            CHAT.socket.emit('event', {
                type: 'init',
                account: account,
                clientId: this.clientId,
                clientType: this.clientType,
                skillGroupId: this.businessId,
                accessKey: this.accessKey,
                reconnect: this.isReconnect,
                source: 'H5'
            }, (res)=>{
                if(res.scene == 'cs'){
                    // 在人工对话中
                    this.queuing = 1;
                }else{
                    this.queuing = 0;
                }
                this.$nextTick(()=>{
                    this.getConversationH();
                });
            });
            if (!this.isReconnect && this.firstConnected) {
                this.firstConnected = false;
            }
            if (this.isReconnect) {
                this.reloadChatHistory();
            }
        },
        /**
         * 通讯连接成功
         *
         * @param {any} res 后台返回的信息
         * @returns
         */
        wsOnmessage(res) {
            if (!res) return;
            if (res && res.content) {
                // 不展示人脸识别结果、身份认证结果
                if (res.type === 'event' && ['facedetection', 'verify'].includes(res.eventKey)) {
                    return;
                }
                if (!res.sender) {
                    res.sender = 'bot';
                }
                this.cid = res.cid;
                if (res.type == 'event' && res.eventKey == 'satisfaction') {
                    let starInfo = this.getStarInfo(res.manual);
                    res.manual.starInfo = starInfo;
                    if (!res.manual.labels) {
                        res.manual.labels = [];
                        res.manual.content = '';
                        res.manual.disabled = false;
                    }
                }
                // if (res.type=='text' && this.businessType == 2) {
                //     const message = res.content;
                //     const extend = res.extend;
                //     const messageArray = message.split(''); // 字符串转成字符数组
                //     res.content = '';
                //     res.extend = null;
                //     this.chatList.push(res);
                //     const len = this.chatList.length - 1;
                //     let counter = 0;
                //     const displayMessage = setInterval(() => {
                //         if (counter === messageArray.length-1) {
                //           clearInterval(displayMessage);
                //           this.chatList[len].extend = extend;
                //         }
                //         this.chatList[len].content += messageArray[counter];
                //         counter++;
                //         this.scrollBottom();
                //     }, 50);
                // }else{
                    this.chatList.push(res);
                    this.scrollBottom();
                // }
                if (this.businessType == 2) {
                    // 解锁输入框（文档问答发送消息后已对输入框上锁）
                    this.$refs.inputArea.unlock();
                }
            }
        },
        /**
         * 聊天内容滚动到底部
         */
        scrollBottom() {
            setTimeout(() => {
                if (this.$refs['conversation']) {
                    this.$refs['conversation'].scrollTop = this.$refs['conversation'].scrollHeight;
                }
            }, 300);
        },
        /**
         * 显示工具栏
         */
        showTool() {
            this.toolShow = !this.toolShow;
            this.$nextTick(()=>{
                document.getElementById('app').scrollTop = this.$refs['webotPage'].scrollHeight;
                setTimeout(() => {
                    if(this.toolShow) {
                        this.conversationH = this.conversationH-this.$refs['tool'].$el.clientHeight;
                    }else {
                        this.getConversationH();
                    }
                    this.scrollBottom();
                }, 300);
            });
        },
        hideTool() {
            this.toolShow = false; 
        },
        /**
         * 打开emoji
         * */
        showEmoji(){
            this.$nextTick(()=>{
                document.getElementById('app').scrollTop = this.$refs['webotPage'].scrollHeight;
                setTimeout(() => {
                    if(this.toolShow) {
                        this.conversationH = this.conversationH-this.$refs['tool'].$el.clientHeight;
                    }else {
                        this.getConversationH();
                    }
                    this.scrollBottom();
                }, 300);
            });
        },
        /**
         * 解决键盘弹起时input被挡
         *
         */
        focusInput() {
            setTimeout(() => {
                document.getElementById('app').scrollTop = this.$refs['webotPage'].scrollHeight;
            }, 400);
        },
        /**
         * 转人工客服-排队
         * */
        transferCustomer(){
            if(this.queue == 1){
                return;
            }
            this.queue = 1;
            let data = {
                type: 'queue:inqueue',
                accessKey: this.accessKey,
                clientId: this.clientId,
                clientType: this.clientType,
                businessId: this.businessId,
                businessName: this.businessName,
                customerType: this.customerType,
                customerDetail: {},
                source: 'H5'
            }
            if(dataHandle.getCookie('X-User-Mobile')&&dataHandle.getCookie('X-User-Mobile') != "undefined") {
                data.account = dataHandle.getCookie('X-User-Mobile');
            }
            let that = this;
            setTimeout(()=>{
                CHAT.socket.emit('event', data, ({ret, msg})=>{
                    if (ret == -1) {
                        // 排队不成功
                        that.chatList.push({
                            type: 'event',
                            content: msg
                        });
                        that.scrollBottom();
                        that.queue = 0;
                    }
                });
            }, 300);
            if (this.toolShow) {
                this.showTool();
            }
        },
        /**
         * 转人工客服-取消排队
         * */
        cancelTransferCustomer(){
            let data = {
                type: 'queue:dequeue',
                clientId: this.clientId,
                clientType: this.clientType,
                accessKey: this.accessKey,
                source: 'H5'
            }
            setTimeout(()=>{
                CHAT.socket.emit('event', data);
                for (var i = this.chatList.length - 1; i >= 0; i--) {
                    if(this.chatList[i].type == 'queue:notify'){
                       this.chatList.splice(i, 1);
                       break; 
                    }
                }
                this.chatList.push({
                    type: 'event',
                    content: '人工客服排队已取消'
                });
                this.queue = 0;
                this.queuing = 0;
                this.scrollBottom();
            }, 300);
        },
        /**
         * 服务评价
         * */
        toggleEvaluate() {
            let data = {
                type: 'satisfaction',
                clientId: this.clientId,
                clientType: this.clientType,
                accessKey: this.accessKey,
                source: 'H5'
            }
            CHAT.socket.emit('event', data, (async (res)=>{
                if (this.toolShow) {
                    await this.showTool();
                }
                if (res.ret == -1) {
                    this.chatList.push({
                        type: 'event',
                        content: res.msg
                    });
                    this.scrollBottom();
                    return;
                }else if (res.ret == 1) {
                    if (this.$refs.comConversation.$refs.satisfaction) {
                        this.$nextTick(()=>{
                            setTimeout(() => {
                                let len = this.$refs.comConversation.$refs.satisfaction.length;
                                this.$refs.comConversation.$refs.satisfaction[len-1].scrollIntoView();
                            }, 700);
                        });
                    }else{
                        this.chatList.push({
                            type: 'event',
                            content: '您已对当前服务进行过评价'
                        });
                        this.scrollBottom();
                    }
                    return;
                }
            }));
        },
        /**
         * 反馈
         * */
        toFeedback(hitType){
            if(!this.cid) {
                Toast('您还未咨询任何问题，无法进行反馈');
                return;
            }
            hitType = hitType == undefined ? 0 : hitType;
            this.$router.push({
                name: 'feedback',
                query: {
                    cid: this.cid,
                    accessKey: this.accessKey,
                    hitType: hitType
                }
            })
        },
        /**
         * 发送服务评价
         * */
        sendSatisfaction(params){
            let data = {
                type: 'satisfaction:commit',
                clientId: this.clientId,
                clientType: this.clientType,
                manual: {
                    level: parseInt(params[1]),
                    labels: params[2],
                    content: params[3],
                    sessionKey: params[0]
                },
                source: 'H5'
            }
            this.scrollBottom();
            setTimeout(()=>{
                CHAT.socket.emit('event', data, (res)=>{
                    Toast(res.msg);
                });
            }, 300);
        },
        /**
         * 退出人工
         * */
        exitCS(){
            let data = {
                type: 'session:close',
                clientId: this.clientId,
                accessKey: this.accessKey
            }
            setTimeout(()=>{
                CHAT.socket.emit('event', data);
            }, 300);
        },
        /**
         * 发送回答完成率
         * */
        sendRateCompletion(params){
            let isLike = params[0] === 'good' ? 1 : 0;
            let data = {
                type: 'like:commit',
                clientId: this.clientId,
                accessKey: this.accessKey,
                msgId: params[1],
                like: isLike
            }
            setTimeout(()=>{
                CHAT.socket.emit('event', data, (res)=>{
                    if (res.ret ===0) {
                        for (var i = this.chatList.length - 1; i >= 0; i--) {
                            if (this.chatList[i].msgId == data.msgId) {
                                this.$set(this.chatList[i].extend, 'like', isLike);
                                break;
                            }
                        }
                    }
                });
            }, 300);
        },
        // 缓存用户输入的号码
        cachePhone() {
            const value = this.phone;
            const reg = /^1[3-9]\d{9}$/;
            if (!value) {
                this.errorText = '请输入注册号码';
                return;
            }
            if(!reg.test(value)){
                this.errorText = '请输入正确的手机号码';
                return;
            }
            dataHandle.setCookie('X-User-Mobile',value);
            this.phone = '';
            this.showModal = false
            this.errorText  = '';
            this.hasMobeil = false
            this.connented();
        }
    },
}


// WEBPACK FOOTER //
// ./src/pages/webot/_webot.js